import { cn } from 'lib/helpers/utility';

import Input from 'components/shared/Input/Input';

const InputWithUnit = ({ unitLabel, className, ...inputProps }) => {
  return (
    <div className="relative flex-1">
      <Input {...inputProps} inputWrapperClassName={cn('pr-[84px]', className)} type="number" />
      <div className="pointer-events-none absolute bottom-0 right-0 flex h-10 items-center rounded-r-md border border-solid border-neutral-200 bg-neutral-50 px-3">
        <p className="whitespace-nowrap text-sm leading-6 text-neutral-900">{unitLabel}</p>
      </div>
    </div>
  );
};

export default InputWithUnit;
